<div id="particles-js"></div>
<div class="mid_body">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="logo">
          <img
            src="{{ onPassiveBaseUrl }}onpassive-october(5)/images/logo.png"
            class="img-fluid"
            alt="logo"
          />
        </div>
      </div>
    </div>
    <div class="mid_box">
      <div class="row">
        <div class="col-lg-4">
          <div class="left_box">
            <h1 class="ml5 text-white">
              LAUNCHING SOON!
            
            </h1>

            <p>
              Artificial intelligence is leaving a noted mark in every walk of
              life. What if you could harvest its power to change your life for
              the best? ONPASSIVE gives you the opportunity to make a fresh
              start in your life through an innovating digital marketing
              platform that is backed up by AI. Join ONPASSIVE to see daily
              returns in your pockets sitting at your home
            </p>
          </div>
          <div class="bfn">
            <a
              href="/registration/user?reg={{ userId }}"
              name="regform"
              class="btn text-uppercase"
              target="_blank"
              rel="noopener"
              >become a founder now</a
            >
          </div>
        </div>
        <div class="col-lg-5">
          <div class="mid_box_one">
            <h2 class="txt anim-text-flow">
              NEW REVOLUTIONIZED INTERNET MARKETING SOLUTIONS
            </h2>
            <div class="video_box acc_panel anim_in">
              <video
                id="my-video"
                class="video-js video-size w-100 h-auto"
                controls
                preload="auto"
                poster="{{ myLinksS3URL }}images/Image0231.png"
                data-setup="{}"
                autoplay="true"
                muted
              >
                <source
                  src="{{
                    myLinksS3URL
                  }}videos/Onpassive_launching_page_video2.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="right_main_box">
            <div class="right_image">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive-october(5)/images/right_image.png"
                class="img-fluid"
                alt="image"
              />
            </div>
            <div class="robot">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive-october(5)/images/robot_image.png"
                class="img-fluid"
                alt="image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
